import SalesRoundFormListbox from '@/components/sale/sales-round-form-listbox';
import NumberFormInput from '@/components/ui/number-form-input';
import { FormProvider } from '@/contexts/form-context';
import { useSalesRoundsQuery } from '@/hooks/sale/queries/use-sales-rounds';
import { useCreateSaleForm } from '@/hooks/sale/use-create-sale.form';
import { CreateSaleResponse } from '@/types/api/sale';
import Skeleton from 'react-loading-skeleton';

interface CreateSaleFormProps {
  onSuccess?: (data: CreateSaleResponse) => void;
}

export default function CreateSaleForm({ onSuccess }: CreateSaleFormProps) {
  const query = useSalesRoundsQuery();

  const rounds = query.data?.sort((a, b) => new Date(a.cutoffAt).getTime() - new Date(b.cutoffAt).getTime());

  const form = useCreateSaleForm(rounds?.[0]?.id, onSuccess);

  return (
    <FormProvider form={form}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
      >
        <div className="space-y-4 mb-8">
          <NumberFormInput name="participationCount" label="Antal deltagare" />
          <NumberFormInput name="participationUnitCountTarget" label="Mål sålda produkter per deltagare" />

          {rounds ? (
            <SalesRoundFormListbox rounds={rounds} name="cutoffId" label="Välj sista beställningsdag" />
          ) : (
            <Skeleton height={100} />
          )}
        </div>

        <div className="flex items-center justify-between">
          <form.Subscribe
            selector={(state) => [state.canSubmit, state.isSubmitting]}
            children={([canSubmit, isSubmitting]) => (
              <button
                type="submit"
                disabled={!canSubmit}
                className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white ml-auto"
              >
                {isSubmitting ? 'Skapar försäljning...' : 'Skapa försäljning'}
              </button>
            )}
          />
        </div>
      </form>
    </FormProvider>
  );
}
